module.exports = __webpack_public_path__ + "cat_professional.svg?9bf95e36be6904a672a6eef34ca995bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat_icons/cat_professional.svg
// module id = 114
// module chunks = 0